import { Navigate } from 'react-router-dom';
import { useAuth } from '@/app/common/hooks/useAuth.ts';
import type { ReactNode } from 'react';

export default function SuperAdminRoute({ children }: { children: ReactNode }) {
  const { user } = useAuth();

  if (!user?.isSuperAdmin) return <Navigate to="/home" replace />;

  return <>{children}</>;
}
